import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { FaKey } from "react-icons/fa6";
//Import from project
import "../../Style/actionstyle.scss";
import { useDeleteImageServer } from "../CropImage/DeleteImageServer";
import StudentForm from "./StudentForm";
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_STUDENT } from "../../Schema/Student";
import DialogDelete from "../../Utils/DialogDelete";
import { hasPermission } from "../../Context/Permission";
import ChangeStudentPassword from "./ChangeStudentPassword";

export default function StudentAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  //Modal password
  const [openPassword, setOpenPassword] = useState(false);
  const handleOpenPassword = () => setOpenPassword(true);
  const handleClosePassword = () => setOpenPassword(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const mutationDelete = useDeleteImageServer();

  const [deleteStudent] = useMutation(DELETE_STUDENT, {
    onCompleted: ({ deleteStudent }) => {
      setLoading(false);
      if (deleteStudent?.isSuccess === true) {
        setAlert(true, "success", deleteStudent?.message);
        handleCloseDel();
        setRefetch();
        if (editData?.profile) {
          let splitSrc = editData?.profile?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", deleteStudent?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteStudent({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {hasPermission(
          userLogin?.user?.role,
          "change_password:change_password",
        ) && (
          <Tooltip title={t("reset_password_mobile")} placement="top">
            <IconButton onClick={handleOpenPassword}>
              <Box className="update-container">
                <FaKey className="update-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title={t("view")} placement="top">
          <IconButton
            onClick={() =>
              navigate(`/student/student-detail?studentId=${editData?._id}`)
            }
          >
            <Box className="view-container">
              <IoMdEye className="view-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openPassword && (
        <ChangeStudentPassword
          open={openPassword}
          handleClose={handleClosePassword}
          editData={editData}
        />
      )}

      {openEdit && (
        <StudentForm
          open={openEdit}
          dialogTitle={"Update"}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_student")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
